@if(field.hasControl) {
    @switch (field.type) {
        @case (_FrontendFieldType.groupBox) {
            <p-fieldset #componentFieldSet
                [class.ng-invalid]="errorMessage != null"
                [class.ng-dirty]="errorMessage != null"
                [pTooltip]="field.tooltipOnControl ? field.tooltip : errorMessage"
                [tooltipStyleClass]="field.tooltipStyleClasses" 
                [legend]="field.caption"
                [style.text-transform]="field.upperCase ? 'uppercase' : null"
                [style.position]="fixedPos ? 'absolute' : undefined"
                [style.left.px]="fixedPos ? field.fixedControlBounds.x : undefined"
                [style.top.px]="fixedPos ? field.fixedControlBounds.y : undefined"
                [style.width.px]="fixedPos ? field.fixedControlBounds.width : undefined"
                [style.height.px]="fixedPos ? field.fixedControlBounds.height : undefined"
                [style.z-index]="'-1'"
                styleClass="transparent"
            >
                <div
                [style.width.px]="fixedPos ? field.fixedControlBounds.width : undefined"
                [style.height.px]="fixedPos ? field.fixedControlBounds.height : undefined"
                >
                </div>
            </p-fieldset>
        }
        @case (_FrontendFieldType.text) {
            <input type="text" #componentInputText pInputText
                [class.ng-invalid]="errorMessage != null"
                [class.ng-dirty]="errorMessage != null"
                [pTooltip]="field.tooltipOnControl ? field.tooltip : errorMessage"
                [tooltipStyleClass]="field.tooltipStyleClasses" 
                [maxLength]="field.maxLength ?? 255"
                [disabled]="!field.enabled"
                [style.text-transform]="field.upperCase ? 'uppercase' : null"
                [style.position]="fixedPos ? 'absolute' : undefined"
                [style.left.px]="fixedPos ? field.fixedControlBounds.x : undefined"
                [style.top.px]="fixedPos ? field.fixedControlBounds.y : undefined"
                [style.width]="fixedPos ? field.fixedControlBounds.width + 'px' : '100%'"
                [style.height.px]="fixedPos ? field.fixedControlBounds.height : undefined"
                [(ngModel)]="field.value"
                (change)="valueChanged()"
            >
        }
        @case (_FrontendFieldType.password) {
            <p-password
                [class.ng-invalid]="errorMessage != null"
                [class.ng-dirty]="errorMessage != null"
                [pTooltip]="field.tooltipOnControl ? field.tooltip : errorMessage"
                [tooltipStyleClass]="field.tooltipStyleClasses" 
                [feedback]="field.passwordFeedback"
                [disabled]="!field.enabled"
                [toggleMask]="true"
                [style.text-transform]="field.upperCase ? 'uppercase' : null"
                [style.position]="fixedPos ? 'absolute' : undefined"
                [style.left.px]="fixedPos ? field.fixedControlBounds.x : undefined"
                [style.top.px]="fixedPos ? field.fixedControlBounds.y : undefined"
                [style.height.px]="fixedPos ? field.fixedControlBounds.height : undefined"
                [style]="{'width': fluentWidth ?? '100%'}"
                [inputStyle]="{'width': fluentWidth ?? '100%'}"
                [(ngModel)]="field.value"
                (change)="valueChanged()"
            ></p-password>
        }
        @case(_FrontendFieldType.int) {
            <p-inputNumber #componentInputNumber
                [class.ng-invalid]="errorMessage != null"
                [class.ng-dirty]="errorMessage != null"
                [pTooltip]="field.tooltipOnControl ? field.tooltip : errorMessage"
                [tooltipStyleClass]="field.tooltipStyleClasses" 
                [name]="field.id"
                [showButtons]="true"
                [format]="false"
                [disabled]="!field.enabled"
                [min]="field.minValue == null ? undefined : field.minValue"
                [max]="field.maxValue == null ? undefined : field.maxValue"
                [style.position]="fixedPos ? 'absolute' : undefined"
                [style.left.px]="fixedPos ? field.fixedControlBounds.x : undefined"
                [style.top.px]="fixedPos ? field.fixedControlBounds.y : undefined"
                [style.width.px]="fixedPos ? field.fixedControlBounds.width : undefined"
                [style.height.px]="fixedPos ? field.fixedControlBounds.height : undefined"
                [style]="fixedPos ? {'width': field.fixedControlBounds.width + 'px', 'height': field.fixedControlBounds.height + 'px'} : undefined"
                [(ngModel)]="field.value"
                (ngModelChange)="valueChanged()"
            >
            </p-inputNumber>
        }
        @case(_FrontendFieldType.decimal) {
            <p-inputNumber #componentInputNumber
                [class.ng-invalid]="errorMessage != null"
                [class.ng-dirty]="errorMessage != null"
                [pTooltip]="field.tooltipOnControl ? field.tooltip : errorMessage"
                [tooltipStyleClass]="field.tooltipStyleClasses" 
                mode="decimal"
                [minFractionDigits]="2" 
                [maxFractionDigits]="2"
                [name]="field.id"
                [showButtons]=true
                [disabled]="!field.enabled"
                [min]="field.minValue == null ? undefined : field.minValue"
                [max]="field.maxValue == null ? undefined : field.maxValue"
                [style.position]="fixedPos ? 'absolute' : undefined"
                [style.left.px]="fixedPos ? field.fixedControlBounds.x : undefined"
                [style.top.px]="fixedPos ? field.fixedControlBounds.y : undefined"
                [style.width.px]="fixedPos ? field.fixedControlBounds.width : undefined"
                [style.height.px]="fixedPos ? field.fixedControlBounds.height : undefined"
                [style]="fixedPos ? {'width': field.fixedControlBounds.width + 'px', 'height': field.fixedControlBounds.height + 'px'} : undefined"
                [(ngModel)]="field.value"
                (ngModelChange)="valueChanged()"
            >
            </p-inputNumber>
        }
        @case(_FrontendFieldType.rating) {
            <p-rating #componentInputNumber
                [class.ng-invalid]="errorMessage != null"
                [class.ng-dirty]="errorMessage != null"
                [pTooltip]="field.tooltipOnControl ? field.tooltip : errorMessage"
                [tooltipStyleClass]="field.tooltipStyleClasses" 
                [name]="field.id"
                [disabled]="!field.enabled"
                [stars]="field.maxValue >= 0 ? field.maxValue : 5"
                [style.position]="fixedPos ? 'absolute' : undefined"
                [style.left.px]="fixedPos ? field.fixedControlBounds.x : undefined"
                [style.top.px]="fixedPos ? field.fixedControlBounds.y : undefined"
                [style.width.px]="fixedPos ? field.fixedControlBounds.width : undefined"
                [style.height.px]="fixedPos ? field.fixedControlBounds.height : undefined"
                [style]="fixedPos ? {'width': field.fixedControlBounds.width + 'px', 'height': field.fixedControlBounds.height + 'px'} : undefined"
                [(ngModel)]="field.value"
                (change)="valueChanged()"
            >
            </p-rating>
        }
        @case(_FrontendFieldType.maskField) {
            <p-inputMask
                [class.ng-invalid]="errorMessage != null"
                [class.ng-dirty]="errorMessage != null"
                [pTooltip]="field.tooltipOnControl ? field.tooltip : errorMessage"
                [tooltipStyleClass]="field.tooltipStyleClasses" 
                [mask]="field.regexMask"
                [maxlength]="field.maxLength ?? 255"
                [disabled]="!field.enabled"
                [style.text-transform]="field.upperCase ? 'uppercase' : null"
                [style.position]="fixedPos ? 'absolute' : undefined"
                [style.left.px]="fixedPos ? field.fixedControlBounds.x : undefined"
                [style.top.px]="fixedPos ? field.fixedControlBounds.y : undefined"
                [style.width.px]="fixedPos ? field.fixedControlBounds.width : undefined"
                [style.height.px]="fixedPos ? field.fixedControlBounds.height : undefined"
                [style]="fixedPos ? {'width': field.fixedControlBounds.width + 'px', 'height': field.fixedControlBounds.height + 'px'} : undefined"
                [(ngModel)]="field.value"
                (onComplete)="valueChanged()"
            >
            </p-inputMask>
        }
        @case(_FrontendFieldType.comboBoxMulti) {
            <p-multiSelect #componentMultiSelect *ngIf="!field.dropdownAutoComplete"
                [class.ng-invalid]="errorMessage != null"
                [class.ng-dirty]="errorMessage != null"
                [pTooltip]="field.tooltipOnControl ? field.tooltip : errorMessage"
                [tooltipStyleClass]="field.tooltipStyleClasses" 
                [options]="field.listItems"
                appendTo="body"
                placeholder="Keine Auswahl"
                [disabled]="!field.enabled"
                [style.text-transform]="field.upperCase ? 'uppercase' : null"
                [style.position]="fixedPos ? 'absolute' : undefined"
                [style.left.px]="fixedPos ? field.fixedControlBounds.x : undefined"
                [style.top.px]="fixedPos ? field.fixedControlBounds.y : undefined"
                [style.width.px]="fixedPos ? field.fixedControlBounds.width : undefined"
                [style.height.px]="fixedPos ? field.fixedControlBounds.height : undefined"
                [style]="fixedPos ? {'width': field.fixedControlBounds.width + 'px', 'height': field.fixedControlBounds.height + 1 + 'px'} : undefined"
                [(ngModel)]="field.value"
                (onChange)="valueChanged()"
            >
            </p-multiSelect>
            <p-autoComplete #componentAutoComplete *ngIf="field.dropdownAutoComplete"
                [class.ng-invalid]="errorMessage != null"
                [class.ng-dirty]="errorMessage != null"
                [pTooltip]="field.tooltipOnControl ? field.tooltip : errorMessage"
                [tooltipStyleClass]="field.tooltipStyleClasses" 
                [suggestions]="autoCompleteSuggestions"
                [dropdown]="field.dropdownButtonVisible"
                field="label"
                dataKey="value"
                appendTo="body"
                [disabled]="!field.enabled"
                [multiple]=true
                [style.text-transform]="field.upperCase ? 'uppercase' : null"
                [style.position]="fixedPos ? 'absolute' : undefined"
                [style.left.px]="fixedPos ? field.fixedControlBounds.x : undefined"
                [style.top.px]="fixedPos ? field.fixedControlBounds.y : undefined"
                [style.width.px]="fixedPos ? field.fixedControlBounds.width : undefined"
                [style.height.px]="fixedPos ? field.fixedControlBounds.height : undefined"
                [style]="fixedPos ? {'width': field.fixedControlBounds.width + 'px', 'height': field.fixedControlBounds.height + 1 + 'px'} : undefined"
                [(ngModel)]="field.value"
                (completeMethod)="autoComplete($event)"
                (onChange)="valueChanged()"
            >
                <ng-template let-item pTemplate="item">
                    <span [class.word-wrap]="field.dropdownWordWrap" [innerHTML]="item.label | keepHtml">
                    </span>
                </ng-template>
            </p-autoComplete>
        }
        @case(_FrontendFieldType.comboBox) {
            <p-dropdown #componentDropdown *ngIf="!field.dropdownAutoComplete"
                [class.ng-invalid]="errorMessage != null"
                [class.ng-dirty]="errorMessage != null"
                [pTooltip]="field.tooltipOnControl ? field.tooltip : errorMessage"
                [tooltipStyleClass]="field.tooltipStyleClasses" 
                [options]="field.listItems"
                optionLabel="label"
                optionValue="value"
                appendTo="body"
                [disabled]="!field.enabled"
                [editable]="field.dropdownEditable"
                [filter]="field.dropdownCanFilter"
                [autoOptionFocus]=true
                [style.text-transform]="field.upperCase ? 'uppercase' : null"
                [style.position]="fixedPos ? 'absolute' : undefined"
                [style.left.px]="fixedPos ? field.fixedControlBounds.x : undefined"
                [style.top.px]="fixedPos ? field.fixedControlBounds.y : undefined"
                [style.width.px]="fixedPos ? field.fixedControlBounds.width : undefined"
                [style.height.px]="fixedPos ? field.fixedControlBounds.height : undefined"
                [style]="fixedPos ? {'width': field.fixedControlBounds.width + 'px', 'height': field.fixedControlBounds.height + 1 + 'px'} : undefined"
                [(ngModel)]="field.value"
                (onChange)="valueChanged()"
                [placeholder]="'\u00A0'"
            >
                <ng-template *ngIf="!field.dropdownEditable" let-item pTemplate="selectedItem">
                    {{_Utils.stringDef(item?.labelPlain ?? item?.label, '\u00A0')}}
                </ng-template>
                <ng-template let-item pTemplate="item">
                    <span [class.word-wrap]="field.dropdownWordWrap" [innerHTML]="_Utils.stringDef(item.html ? (item.label | keepHtml) : item.label, '\u00A0')">
                    </span>
                </ng-template>
            </p-dropdown>
            <p-autoComplete #componentAutoComplete *ngIf="field.dropdownAutoComplete"
                [class.ng-invalid]="errorMessage != null"
                [class.ng-dirty]="errorMessage != null"
                [pTooltip]="field.tooltipOnControl ? field.tooltip : errorMessage"
                [tooltipStyleClass]="field.tooltipStyleClasses" 
                [suggestions]="autoCompleteSuggestions"
                [dropdown]="field.dropdownButtonVisible"
                field="label"
                dataKey="value"
                appendTo="body"
                [disabled]="!field.enabled"
                [forceSelection]="true" 
                [style.text-transform]="field.upperCase ? 'uppercase' : null"
                [style.position]="fixedPos ? 'absolute' : undefined"
                [style.left.px]="fixedPos ? field.fixedControlBounds.x : undefined"
                [style.top.px]="fixedPos ? field.fixedControlBounds.y : undefined"
                [style.width.px]="fixedPos ? field.fixedControlBounds.width : undefined"
                [style.height.px]="fixedPos ? field.fixedControlBounds.height : undefined"
                [style]="fixedPos ? {'width': field.fixedControlBounds.width + 'px', 'height': field.fixedControlBounds.height + 1 + 'px'} : undefined"
                [(ngModel)]="field.value"
                (completeMethod)="autoComplete($event)"
                (ngModelChange)="valueChanged()"
            >
                <ng-template let-item pTemplate="item">
                    <span [class.word-wrap]="field.dropdownWordWrap" [innerHTML]="item.label | keepHtml">
                    </span>
                </ng-template>
            </p-autoComplete>
        }
        @case(_FrontendFieldType.comboBoxCascade) {
            <p-cascadeSelect
                [class.ng-invalid]="errorMessage != null"
                [class.ng-dirty]="errorMessage != null"
                [pTooltip]="field.tooltipOnControl ? field.tooltip : errorMessage"
                [tooltipStyleClass]="field.tooltipStyleClasses" 
                [disabled]="!field.enabled"
                [name]="field.id"
                optionLabel="label"
                optionGroupLabel="label"
                appendTo="body"
                [optionGroupChildren]="['children', 'children', 'children', 'children', 'children', 'children', 'children', 'children', 'children', 'children']"
                [style.text-transform]="field.upperCase ? 'uppercase' : null"
                [style.position]="fixedPos ? 'absolute' : undefined"
                [style.left.px]="fixedPos ? field.fixedControlBounds.x : undefined"
                [style.top.px]="fixedPos ? field.fixedControlBounds.y : undefined"
                [style.width.px]="fixedPos ? field.fixedControlBounds.width : undefined"
                [style.height.px]="fixedPos ? field.fixedControlBounds.height : undefined"
                [style]="fixedPos ? {'width': field.fixedControlBounds.width + 'px', 'height': field.fixedControlBounds.height + 1 + 'px'} : undefined"
                [(ngModel)]="field.value"
                (onChange)="valueChanged()"
            >
            </p-cascadeSelect>
        }
        @case(_FrontendFieldType.listBox) {
            <p-listbox
                class="full-height"
                [class.ng-invalid]="errorMessage != null"
                [class.ng-dirty]="errorMessage != null"
                [pTooltip]="field.tooltipOnControl ? field.tooltip : errorMessage"
                [tooltipStyleClass]="field.tooltipStyleClasses" 
                [options]="field.listItems"
                [disabled]="!field.enabled"
                [checkbox]="field.listBoxCheckBoxes"
                [multiple]="field.listBoxCheckBoxes"
                [style.text-transform]="field.upperCase ? 'uppercase' : null"
                [style.position]="fixedPos ? 'absolute' : undefined"
                [style.left.px]="fixedPos ? field.fixedControlBounds.x : undefined"
                [style.top.px]="fixedPos ? field.fixedControlBounds.y : undefined"
                [style.width.px]="fixedPos ? field.fixedControlBounds.width : undefined"
                [style.height.px]="fixedPos ? field.fixedControlBounds.height : undefined"
                [style]="{width: fluentWidth ?? '100%', height: field.fixedHeight || '200px'}"
                [(ngModel)]="field.value"
                (onChange)="valueChanged()"
            >
            </p-listbox>
        }
        @case(_FrontendFieldType.textArea) {
            <textarea
                pInputTextarea
                spellcheck=false
                [class.ng-invalid]="errorMessage != null"
                [class.ng-dirty]="errorMessage != null"
                [pTooltip]="field.tooltipOnControl ? field.tooltip : errorMessage"
                [tooltipStyleClass]="field.tooltipStyleClasses" 
                [maxLength]="field.maxLength ?? 65535"
                [disabled]="!field.enabled"
                [style.text-transform]="field.upperCase ? 'uppercase' : null"
                [style.position]="fixedPos ? 'absolute' : undefined"
                [style.left.px]="fixedPos ? field.fixedControlBounds.x : undefined"
                [style.top.px]="fixedPos ? field.fixedControlBounds.y : undefined"
                [style.width.px]="fixedPos ? field.fixedControlBounds.width : undefined"
                [style.height.px]="fixedPos ? field.fixedControlBounds.height : undefined"
                [style.resize]="'none'"
                [style.font-family]="field.monospaced ? 'monospace' : undefined"
                [style]="{width: fluentWidth ?? '100%', height: field.fixedHeight || '200px'}"
                [(ngModel)]="field.value"
                (input)="valueChanged()"
            >
            </textarea>
        }
        @case(_FrontendFieldType.datePicker) {
            @if (field.datePickerYear || field.datePickerMonth) {
                <p-calendar
                    dateFormat="dd.mm.yy"
                    [class.ng-invalid]="errorMessage != null"
                    [class.ng-dirty]="errorMessage != null"
                    [pTooltip]="field.tooltipOnControl ? field.tooltip : errorMessage"
                    [tooltipStyleClass]="field.tooltipStyleClasses" 
                    [disabled]="!field.enabled"
                    [style.position]="fixedPos ? 'absolute' : undefined"
                    [style.left.px]="fixedPos ? field.fixedControlBounds.x : undefined"
                    [style.top.px]="fixedPos ? field.fixedControlBounds.y : undefined"
                    [style.width.px]="fixedPos ? field.fixedControlBounds.width : undefined"
                    [style.height.px]="fixedPos ? field.fixedControlBounds.height : undefined"
                    [inputStyle]="getStyle(fixedPos ? {'width': field.fixedControlBounds.width + 'px', 'height': field.fixedControlBounds.height + 'px'} : {'width': '100%'})"
                    [style]="{'width': fluentWidth ?? '100%'}"
                    [view]="field.datePickerYear ? 'year' : field.datePickerMonth ? 'month' : 'date'"
                    [dateFormat]="field.datePickerYear ? 'yy' : field.datePickerMonth ? 'mm.yy' : null"
                    [(ngModel)]="field.value"
                    appendTo="body"
                    [firstDayOfWeek]=1
                    [showTime]="field.datePickerWithTime"
                    (onInput)="valueChanged()"
                    (onClose)="valueChanged()"
                >
                </p-calendar>
            }
            @else {
                <!-- Das müssen wir leider machen, weil wenn wir dateFormat = null/undefined übergeben, immer das englische Defaultformat verwendet wird -->
                <p-calendar
                    dateFormat="dd.mm.yy"
                    [class.ng-invalid]="errorMessage != null"
                    [class.ng-dirty]="errorMessage != null"
                    [pTooltip]="field.tooltipOnControl ? field.tooltip : errorMessage"
                    [tooltipStyleClass]="field.tooltipStyleClasses" 
                    [disabled]="!field.enabled"
                    [style.position]="fixedPos ? 'absolute' : undefined"
                    [style.left.px]="fixedPos ? field.fixedControlBounds.x : undefined"
                    [style.top.px]="fixedPos ? field.fixedControlBounds.y : undefined"
                    [style.width.px]="fixedPos ? field.fixedControlBounds.width : undefined"
                    [style.height.px]="fixedPos ? field.fixedControlBounds.height : undefined"
                    [inputStyle]="getStyle(fixedPos ? {'width': field.fixedControlBounds.width + 'px', 'height': field.fixedControlBounds.height + 'px'} : {'width': '100%'})"
                    [style]="{'width': fluentWidth ?? '100%'}"
                    [(ngModel)]="field.value"
                    appendTo="body"
                    [firstDayOfWeek]=1
                    [showTime]="field.datePickerWithTime"
                    (onInput)="valueChanged()"
                    (onClose)="valueChanged()"
                >
                </p-calendar>
            }
        }
        @case(_FrontendFieldType.checkBox) {
            <p-checkbox
                [class.ng-invalid]="errorMessage != null"
                [class.ng-dirty]="errorMessage != null"
                [pTooltip]="field.tooltipOnControl ? field.tooltip : errorMessage"
                [tooltipStyleClass]="field.tooltipStyleClasses" 
                [binary]="true"
                [(ngModel)]="field.value"
                [label]="field.caption"
                [disabled]="!field.enabled"
                [style.position]="fixedPos ? 'absolute' : undefined"
                [style.left.px]="fixedPos ? field.fixedControlBounds.x : undefined"
                [style.top.px]="fixedPos ? field.fixedControlBounds.y : undefined"
                [style.width.px]="fixedPos ? field.fixedControlBounds.width - 50 : undefined"
                [style.height.px]="fixedPos ? field.fixedControlBounds.height : undefined"
                (onInput)="valueChanged()"
                (onChange)="valueChanged()"
            >
            </p-checkbox>
        }
        @case(_FrontendFieldType.radioButton) {
            <p-radioButton
                [class.ng-invalid]="errorMessage != null"
                [class.ng-dirty]="errorMessage != null"
                [pTooltip]="field.tooltipOnControl ? field.tooltip : errorMessage"
                [tooltipStyleClass]="field.tooltipStyleClasses" 
                [(ngModel)]="(mainRadioButtonField ?? field).value"
                [name]="field.radioButtonGroup"
                [value]="field.radioButtonValue"
                [label]="field.caption"
                [disabled]="!field.enabled"
                [style.position]="fixedPos ? 'absolute' : undefined"
                [style.left.px]="fixedPos ? field.fixedControlBounds.x : undefined"
                [style.top.px]="fixedPos ? field.fixedControlBounds.y : undefined"
                [style.width.px]="fixedPos ? field.fixedControlBounds.width - 50 : undefined"
                [style.height.px]="fixedPos ? field.fixedControlBounds.height : undefined"
                (ngModelChange)="valueChanged()"
            >
            </p-radioButton>
        }
        @case(_FrontendFieldType.color) {
            <ng-container>
                <sm-color-editor *ngIf="field.predefinedColors == null"
                    [class.ng-invalid]="errorMessage != null"
                    [class.ng-dirty]="errorMessage != null"
                    [pTooltip]="field.tooltipOnControl ? field.tooltip : errorMessage"
                    [tooltipStyleClass]="field.tooltipStyleClasses" 
                    [(value)]="field.value"
                    [style.position]="fixedPos ? 'absolute' : undefined"
                    [style.left.px]="fixedPos ? field.fixedControlBounds.x : undefined"
                    [style.top.px]="fixedPos ? field.fixedControlBounds.y : undefined"
                    [style.width.px]="fixedPos ? field.fixedControlBounds.width - 50 : undefined"
                    [style.height.px]="fixedPos ? field.fixedControlBounds.height : undefined"
                    (valueChange)="valueChanged()"
                >
                </sm-color-editor>
                <ngx-colors ngx-colors-trigger [ngModel]="_Utils.toColorHexString(field.value)" [palette]="getColorPalette()" (input)="colorChanged($event)"></ngx-colors>
            </ng-container>
        }
        @case(_FrontendFieldType.button) {
            <p-button
                [class.ng-invalid]="errorMessage != null"
                [class.ng-dirty]="errorMessage != null"
                [pTooltip]="field.tooltipOnControl ? field.tooltip : errorMessage"
                [tooltipStyleClass]="field.tooltipStyleClasses" 
                [label]="field.caption"
                [disabled]="!field.enabled"
                [style.position]="fixedPos ? 'absolute' : undefined"
                [style.left.px]="fixedPos ? field.fixedControlBounds.x : undefined"
                [style.top.px]="fixedPos ? field.fixedControlBounds.y : undefined"
                [style.width.px]="fixedPos ? field.fixedControlBounds.width : undefined"
                [style.height.px]="fixedPos ? field.fixedControlBounds.height : undefined"
                styleClass="width100p"
                (onClick)="buttonClick($event)"
            >
            </p-button>
        }
        @case(_FrontendFieldType.buttonAsLink) {
            <a
                class="mouse-pointer"
                [class.ng-invalid]="errorMessage != null"
                [class.ng-dirty]="errorMessage != null"
                [pTooltip]="field.tooltipOnControl ? field.tooltip : errorMessage"
                [tooltipStyleClass]="field.tooltipStyleClasses" 
                [style.position]="fixedPos ? 'absolute' : undefined"
                [style.left.px]="fixedPos ? field.fixedControlBounds.x : undefined"
                [style.top.px]="fixedPos ? field.fixedControlBounds.y : undefined"
                [style.width.px]="fixedPos ? field.fixedControlBounds.width : undefined"
                [style.height.px]="fixedPos ? field.fixedControlBounds.height : undefined"
                (click)="buttonClick($event)"
            >
            {{field.caption}}
            </a>
        }
        @case(_FrontendFieldType.stringList) {
            <p-chips
                [class.ng-invalid]="errorMessage != null"
                [class.ng-dirty]="errorMessage != null"
                [pTooltip]="field.tooltipOnControl ? field.tooltip : errorMessage"
                [tooltipStyleClass]="field.tooltipStyleClasses" 
                [(ngModel)]="field.value"
                [disabled]="!field.enabled"
                [style.position]="fixedPos ? 'absolute' : undefined"
                [style.left.px]="fixedPos ? field.fixedControlBounds.x : undefined"
                [style.top.px]="fixedPos ? field.fixedControlBounds.y : undefined"
                [style.width.px]="fixedPos ? field.fixedControlBounds.width : undefined"
                [style.height.px]="fixedPos ? field.fixedControlBounds.height : undefined"
                (onAdd)="valueChanged()"
                (onRemove)="valueChanged()"
            >
            </p-chips>
        }
        @case(_FrontendFieldType.fileUpload) {
            <app-sm-file-upload
                [class.ng-invalid]="errorMessage != null"
                [class.ng-dirty]="errorMessage != null"
                [pTooltip]="field.tooltipOnControl ? field.tooltip : errorMessage"
                [tooltipStyleClass]="field.tooltipStyleClasses" 
                [(value)]="field.value"
                [style.position]="fixedPos ? 'absolute' : undefined"
                [style.left.px]="fixedPos ? field.fixedControlBounds.x : undefined"
                [style.top.px]="fixedPos ? field.fixedControlBounds.y : undefined"
                [style.width.px]="fixedPos ? field.fixedControlBounds.width : undefined"
                [style.height.px]="fixedPos ? field.fixedControlBounds.height : undefined"
                (onValueChanged)="valueChanged()"
            >
            </app-sm-file-upload>
        }
        @case(_FrontendFieldType.imageUpload) {
            <app-sm-image-upload
                [class.ng-invalid]="errorMessage != null"
                [class.ng-dirty]="errorMessage != null"
                [pTooltip]="field.tooltipOnControl ? field.tooltip : errorMessage"
                [tooltipStyleClass]="field.tooltipStyleClasses" 
                [(value)]="field.value"
                [style.position]="fixedPos ? 'absolute' : undefined"
                [style.left.px]="fixedPos ? field.fixedControlBounds.x : undefined"
                [style.top.px]="fixedPos ? field.fixedControlBounds.y : undefined"
                [style.width.px]="fixedPos ? field.fixedControlBounds.width : undefined"
                [style.height.px]="fixedPos ? field.fixedControlBounds.height : undefined"
                (onValueChanged)="valueChanged()"
            >
            </app-sm-image-upload>
        }
        @case(_FrontendFieldType.table) {
            <sm-table2 #componentTable
                [class.ng-invalid]="errorMessage != null"
                [class.ng-dirty]="errorMessage != null"
                [pTooltip]="field.tooltipOnControl ? field.tooltip : errorMessage"
                [tooltipStyleClass]="field.tooltipStyleClasses" 
                [readOnly]="!field.enabled"
                [disabled]="!field.enabled"
                [allowFilter]=false
                [allowAddRow]="field.tableCanAddRow"
                [allowRemoveRow]="field.tableCanRemoveRow"
                [allowRowDrag]="field.tableAllowRowDrag"
                [addRowOnTabInLastCell]="field.tableAddRowOnTabInLastCell"
                [performAddTableRow]="_addTableRow"
                [performRemoveTableRow]="_removeTableRow"
                [performSetTableRows]="_setTableRows"
                [mustRefresh]="_mustRefresh"
                [useColumnMenu]=false
                [data]="tableData"
                [style.position]="fixedPos ? 'absolute' : undefined"
                [style.left.px]="fixedPos ? field.fixedControlBounds.x : undefined"
                [style.top.px]="fixedPos ? field.fixedControlBounds.y : undefined"
                [style.width.px]="fixedPos ? field.fixedControlBounds.width : undefined"
                [style.height]="fixedPos ? field.fixedControlBounds.height + 'px' : field.fixedHeight || '150px'"
                [style.background]="'lightgray'"
                (onRowSelect)="tableSelectRow($event)"
                (onEditInit)="tableEditInit()"
                (onCellValueChanged)="tableEditComplete()"
                [fullScreenRowEditor]="field.fullScreenRowEditorOnMobile"
                [displaySideBar]=false
            >
            </sm-table2>
        }
        @case(_FrontendFieldType.pageControl) {
            <p-tabView
                class="tab-view-no-clip full-height"
                [class.ng-invalid]="errorMessage != null"
                [class.ng-dirty]="errorMessage != null"
                [pTooltip]="field.tooltipOnControl ? field.tooltip : errorMessage"
                [tooltipStyleClass]="field.tooltipStyleClasses" 
                [style.position]="fixedPos ? 'absolute' : undefined"
                [style.left.px]="fixedPos ? field.fixedControlBounds.x : undefined"
                [style.top.px]="fixedPos ? field.fixedControlBounds.y : undefined"
                [style.width.px]="fixedPos ? field.fixedControlBounds.width : undefined"
                [style.height]="fixedPos ? field.fixedControlBounds.height + 'px' : field.fixedHeight || '150px'"
                [style.background]="'lightgray'"  
                [(activeIndex)]="field.pageSelected"              
            >
            @for (page of field.children; track page; let i = $index) {
                <p-tabPanel [header]="page.caption" class="overflow-y-clip">
                    <app-sm-form-group [form]="form" [fields]="pageChildren[i]"></app-sm-form-group>
                </p-tabPanel>
            }
            </p-tabView>
        }
    }
}
<ng-template [insertionPoint]></ng-template>
